module.exports = __webpack_public_path__ + "img/10.b6383808.webp";